import { useEffect } from 'react';
import { scrollToElement } from '../helpers/scroll';

export const usePageScroller = (text: string): void => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const elementId = params.get('elementId');

    if (elementId && text.includes(elementId)) {
      scrollToElement(text, elementId);
    }
  }, [text]);
};
